import { render, staticRenderFns } from "./tabhover.vue?vue&type=template&id=0ed5e00a&scoped=true&"
import script from "./tabhover.vue?vue&type=script&lang=js&"
export * from "./tabhover.vue?vue&type=script&lang=js&"
import style0 from "./tabhover.vue?vue&type=style&index=0&id=0ed5e00a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed5e00a",
  null
  
)

export default component.exports